import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

// Failures
export const GetFailuresFiltersRequest = (role) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}DualMap/GetFailuresFilters`,
	params: { role }
});

export const GetFailuresPointsVoiceRequest = (userId, role, type, city, dates, logs, failureType, cfn1Level) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}DualMap/GetFailuresPoints`,
	data: { userId, role, type, city, dates, logs, failureType, cfn1Level }
});

export const GetFailuresPointsPacketRequest = (userId, role, type, city, dates, logs, failureType, cfn1Level) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}DualMap/GetFailuresPoints`,
	data: { userId, role, type, city, dates, logs, failureType, cfn1Level }
});

// DriveTests
export const GetDriveTestsCitiesRequest = (userId, userOperator) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}DualMap/GetDriveTestsCities`,
	params: { userId, userOperator }
});

export const GetDriveTestsDrivesRequest = (city) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}DualMap/GetDriveTestsDrives`,
	params: { city }
});

export const GetDriveTestsDatesRequest = (city, drive) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}DualMap/GetDriveTestsDates`,
	params: { city, drive }
});

export const GetDriveTestsLogsRequest = (city, dates) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}DualMap/GetDriveTestsLogs`,
	data: { city, dates }
});

export const GetDriveTestRequest = (userId, tech, city, dates, logs, kpi) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}DualMap/GetDriveTest`,
	data: { userId, tech, city, dates, logs, kpi }
});

export const GetUeRouteRequest = (userId, city, dates, logs) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}DualMap/GetUeRoute`,
	data: { userId, city, dates, logs }
});

// Scanner
export const GetDriveTestScannerFrequenciesRequest = (userId, tech, city, dates, freq, top) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}DualMap/GetDriveTestScannerFrequencies`,
	data: { userId, tech, city, dates, freq, top }
});

export const GetDriveTestScannerCodesRequest = (userId, tech, city, dates, freq, top) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}DualMap/GetDriveTestScannerCodes`,
	data: { userId, tech, city, dates, freq, top }
});

export const GetDriveTestScannerRequest = (userId, tech, city, dates, kpi, freq, top, code) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}DualMap/GetDriveTestScanner`,
	data: { userId, tech, city, dates, kpi, freq, top, code }
});

// Crowdsourcing
export const GetCrowdsourcingRequest = (userId, tech, city, dates, kpi) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}DualMap/GetCrowdsourcing`,
	data: { userId, tech, city, dates, kpi }
});

// Topology
export const GetTopologyRequest = (userId, tech, bands, coordinates) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}DualMap/GetTopology`,
	data: { userId, tech, bands, coordinates }
});

export const GetScannerRouteRequest = (userId, city, dates) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}DualMap/GetScannerRoute`,
	data: { userId, city, dates }
});

export const GetSitesIdsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}DualMap/GetSitesIds`,
});

export const GetSiteIdLocationRequest = (siteId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}DualMap/GetSiteIdLocation`,
	params: { siteId }
});

export const GetCarriersColorsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}DualMap/GetCarriersColors`,
});

export const SaveCarrierColorRequest = (userId, tableId, colorCode) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}DualMap/SaveCarrierColor`,
	data: { userId, tableId, colorCode }
});

export const UploadCustomLayerRequest = (folder, userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}DualMap/UploadCustomLayer`,
	params: { folder, userId }
});

export const GetCustomLayerRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}DualMap/GetCustomLayer`,
	params: { userId }
});

// Export
export const ExportScannerRequest = (drive, dates) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}DualMap/ExportScanner`,
	data: { drive, dates }
});

// Extra Map
export const RunXcapToolRequest = (userId, folderPath) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}DualMap/RunXcapTool`,
	params: { userId, folderPath }
});
